module.exports = __webpack_public_path__ + "img/b5.895b8408.png";